import React, { useEffect ,useState } from 'react'
import styled from 'styled-components';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ChatInput from "../Components/ChatInput"
import ChatMessage from "./ChatMessage"
import db from "../firebase"
import { useParams } from 'react-router-dom'
import firebase1 from "firebase"

function Chat({user}) {
    //functionsIn

    let {channelId} =useParams();
    const [channel, setChannel] = useState();
    const [message, setMessages] = useState([]);
 
    const getMessages = () =>{
        db.collection('rooms')
        .doc(channelId)
        .collection('messages')
        .orderBy('timestamp','asc')
        .onSnapshot((snapshot)=>{
            let messages = snapshot.docs.map((doc)=>doc.data());
            console.log("getmessage()=> "+messages);
            setMessages(messages);
        })
    }
    
    const sendMessage = (text1) =>{
        if(channelId){
            console.log("Text Enterned was "+text1+" right now in sendMessgae");
            let payload ={
                text: text1,
                user: user.name,
                timestamp: firebase1.firestore.Timestamp.now(),
                usrimg: user.pic

            }
            console.log("ChannelID is ="+channelId+"  payload:"+" text:"+payload.text+", user:"+ payload.user+
            ", usring: "+user.pic );

            db.collection("rooms").doc(channelId).collection("messages").add(payload);
        }
    }
    
    const getChannel = () =>{
        db.collection('rooms').doc(channelId)
        .onSnapshot((snapshot)=>{
            // console.log("Snapshot data "+JSON.stringify(snapshot.data()));
            setChannel(snapshot.data());
            // console.log("Channel state:"+JSON.stringify(channel.name))
        })
    }


    useEffect(()=>{
                    getChannel();
                    getMessages();
                },[channelId])

    // console.log("channelId: "+channelId);
    //dom

   

    return (
        <Container>

            <Header>
                
                <Channel>
    
                    <ChannelName>
                    #   {channel && channel.name}
                    </ChannelName>
                    
                    <Channel_info>
                        Discover an interesting pedagogy-related fact? Have a pedagogy-related question? Made a pedagogy-related accomplishment? Share them with our class here!
                    </Channel_info>

                </Channel>

                <ChannelDetails>
                    <div>Details</div>
                    <Info/>
                </ChannelDetails>
            </Header>
            
            <MessageContainer>
                {
                    message.length > 0 && 
                    message.map((data,index)=>(
                
                        <ChatMessage  
                        text={data.text} 
                        timestamp={data.timestamp}
                        usrimg={data.usrimg}
                        user={data.user}/>
                ))
                
                }
            </MessageContainer>


         <ChatInput sendMessage={sendMessage}/>
        </Container>

    )
}

export default Chat

const Container = styled.div`
display:grid;
grid-template-rows: 64px auto min-content ;
min-height:0;
`
const Header = styled.div`
padding-left:20px;
padding-right:20px;
display:flex;
align-items:center;
border-bottom: 1px solid rgba(83,39,83,.13);
justify-content:space-between;
`
const MessageContainer = styled.div`
display: flex;
overflow-y: scroll;
flex-direction:column;
`
// const ChatInput = styled.div`


// `
const Channel = styled.div`
// padding:20px;

`
const ChannelName = styled.div`

font-weight:700;
display:block;

`
const Channel_info = styled.div`
// background:black;
    font-weight:400;
    color: #606060;
    font-size:13px;
    margin-top:8px;
`
const ChannelDetails = styled.div`
display:flex;
align-items:center;
color:#606060;
`

const Info = styled(HelpOutlineIcon)`
margin-left:10px;

`